import React, { useRef, useEffect, useState } from "react";

function useClickOutside(ref, handler) {
  useEffect(() => {
    const handleClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        handler();
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [ref, handler]);
}

export const RoomInfoPopup = ({ setFieldValue, values, onClose }) => {
  const popupRef = useRef();
  useClickOutside(popupRef, onClose);
  const [tempValues, setTempValues] = useState({
    noOfRooms: values?.noOfRooms || 1,
    noOfAdult: values?.noOfAdult || 1,
    noOfChild: values?.noOfChild || 0,
    childAges: values?.childAges || [],
  });
  useEffect(() => {
    setTempValues({
      noOfRooms: values?.noOfRooms || 1,
      noOfAdult: values?.noOfAdult || 1,
      noOfChild: values?.noOfChild || 0,
      childAges: values?.childAges || [],
    });
  }, [values]);

  const updateTempField = (field, newValue) => {
    setTempValues((prev) => {
      let updated = { ...prev, [field]: newValue };
      if (field === "noOfRooms") {
        if (updated.noOfAdult < newValue) {
          updated.noOfAdult = newValue;
        }
      }

      if (field === "noOfChild") {
        const prevAges = prev.childAges || [];
        if (newValue > prevAges.length) {
          updated.childAges = [
            ...prevAges,
            ...Array(newValue - prevAges.length).fill("1"),
          ];
        } else {
          updated.childAges = prevAges.slice(0, newValue);
        }
      }

      return updated;
    });
  };

  const handleApply = () => {
    setFieldValue("noOfRooms", tempValues.noOfRooms);
    setFieldValue("noOfAdult", tempValues.noOfAdult);
    setFieldValue("noOfChild", tempValues.noOfChild);
    setFieldValue("childAges", tempValues.childAges);
    onClose();
  };

  const renderCounter = (field, label, subLabel, max = null) => {
    const value = tempValues[field];
    let minVal = 1;
    if (field === "noOfChild") minVal = 0;
    if (field === "noOfAdult") minVal = tempValues.noOfRooms;

    const isDecDisabled = value <= minVal;
    const isIncDisabled = max && value >= max;

    return (
      <div className="DT--passenger-item">
        <div className="DT--passenger-info">
          <div className="DT--passenger-label">
            <b>{label}</b> {subLabel && `(${subLabel})`}
          </div>
        </div>
        <div className="DT--counter">
          <button
            disabled={isDecDisabled}
            onClick={(e) => {
              e.stopPropagation();
              updateTempField(field, value - 1);
            }}
          >
            -
          </button>
          <div className="DT--counter-display">
            <div className="DT--counter-value">{value}</div>
          </div>
          <button
            disabled={isIncDisabled}
            onClick={(e) => {
              e.stopPropagation();
              updateTempField(field, value + 1);
            }}
          >
            +
          </button>
        </div>
      </div>
    );
  };

  return (
    <div
      ref={popupRef}
      className="DT--card-container"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="DT--section">
        {renderCounter("noOfRooms", "Rooms", "Max 9", 9)}
        {renderCounter("noOfAdult", "Adults", "12+ years")}
        {renderCounter("noOfChild", "Children", "0-12 years")}

        {tempValues.noOfChild > 0 && (
          <>
            <hr />
            <label>Age of Children</label>
            {Array.from({ length: tempValues.noOfChild }).map((_, childIndex) => (
              <div key={childIndex} className="hw-dt--selectChild">
                <label>Child {childIndex + 1}</label>
                <select
                  value={tempValues.childAges[childIndex] || "0"}
                  onChange={(e) => {
                    const newAges = [...tempValues.childAges];
                    newAges[childIndex] = e.target.value;
                    setTempValues((prev) => ({ ...prev, childAges: newAges }));
                  }}
                >
                  {Array.from({ length: 13 }, (_, i) => (
                    <option key={i} value={i}>
                      {i}
                    </option>
                  ))}
                </select>
              </div>
            ))}
          </>
        )}

        <hr />
        <button className="hw-btn hw-btn--primary" onClick={handleApply}>
          Apply
        </button>
      </div>
    </div>
  );
};